import React, { useEffect, useState, useCallback } from "react";
import { ReactifySearchLiquidFactory } from "@usereactify/search";
import { MainSearch } from "../search/components/MainSearch";
import config from "@app/config";
import { createRoot } from "react-dom/client";

if (window.location.pathname.startsWith("/search")) {
  const ReactifySearchFactory = new ReactifySearchLiquidFactory({
    ...config.reactify,
    mode: "search",
  });
  const ReactifySearchProvider = ReactifySearchFactory.getProvider();
  const ReactifySearchMountNode = ReactifySearchFactory.getMountNode();
  const root = createRoot(ReactifySearchMountNode!);

  root.render(
    <React.StrictMode>
      <ReactifySearchProvider>
        <MainSearch />
      </ReactifySearchProvider>
    </React.StrictMode>
  );
}
